/** @format */
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { INLINES } from '@contentful/rich-text-types';

import {
    defaultDocumentOptions,
    getRenderers,
} from '@toucan/client/features/contentful';
import { EntryType } from '@toucan/client/features/contentful/config/page-data';

import { ContentfulCaptionProps } from './type';

export const ContentfulCaption = ({ caption }: ContentfulCaptionProps) => {
    const options = {
        ...defaultDocumentOptions,
        renderNode: {
            ...defaultDocumentOptions.renderNode,
            [INLINES.EMBEDDED_ENTRY]: getRenderers(
                EntryType.INLINE,
                caption?.links
            ),
        },
    };

    if (!caption?.json) {
        return null;
    }

    return documentToReactComponents(caption.json, options);
};
